import {analyticsLogEvent} from '../api'

interface ClickEventParams {
    productId: string
    productDescription: string
}

/**
 * Tracks the click on a related product inside a product details page.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {EventCustomAction} params.productId - The analytics product ID (master) of the clicked product.
 * @param {EventCustomLabel} params.productDescription - The related product description.
 */
export function analyticsProductRelatedClick({productId, productDescription}: ClickEventParams) {
    const eventDetails = {
        eventCategory: 'pdp_multisize_click',
        eventAction: productDescription,
        eventLabel: productId,
    }

    analyticsLogEvent('custom_event', eventDetails)
}
